import styled from 'styled-components';
import { greenColor } from 'js/config/style';
import showEllipsis from './showEllipsis';

export default styled.div`
  font-size: 1rem;
  font-weight: 500;
  padding-top: 25%
  color: #6D60F6;
  ${({ ellipsis }) => ellipsis && showEllipsis}
`;
